import React, { useContext } from 'react';
import Loading from './Loading';
import MyParticipateWaysContext from '../context/ParticipateWaysContext';

const ParticipateItem2 = ({participateWay, number}) => {
    const { files, getFile, loading } = useContext(MyParticipateWaysContext);


    const wayDate = new Date(participateWay.participateWayCreationDate);
    const options = {
        weekday: "short",
        day: "numeric",
        month: "long",
        year: "numeric",
    };
    const newDateFormated = wayDate.toLocaleDateString("es-ES", options);
    const showYoutubeVideo = () => {
        return(
            <iframe className='w-full my-5 2sm:w-[90%] lg:w-[45%] 2md:w-[80%] h-[250px] md:h-[300px]' src={participateWay.participateWayVideoPath} title="Catastro" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
        )
    }

    const showImage = () => {
        return(
            <img
            src={`data:image/png;base64,${files[number]}`}
            alt={"newN.newTitle"}
            className="rounded-xl sm:w-[90%] 2sm:w-[80%] md:w-[70%] 2md:w-[60%] lg:w-[45%] 2lg:w-[40%] drop-shadow-lg"
            />
        )
    }

    return (
        <div className='w-full bg-neiva-background bg-cover bg-bottom'>
            <div className='flex flex-col items-center justify-around w-full h-full px-4 py-12 bg-teal-900  bg-opacity-70'>
                <div className='flex flex-col lg:flex-row items-start justify-around w-full'>
                    <div className='flex flex-col justify-around items-around 2sm:w-[90%] lg:w-[45%] 2md:w-[80%] w-full text-white gap-4'>
                        <div>
                            <h1 className='font-bold 2sm:text-4xl text-2xl font-mono text-center'>{participateWay.participateWayTitle}</h1>
                            <div className='flex flex-row justify-around items-center w-full'>
                                <h2 className={`pt-2 flex flex-row text-gray-300 text-sm 2sm:text-base`} >{newDateFormated}</h2>
                                {participateWay.participateWayFilePath ? loading ? <Loading isLoading={true} /> : <button className="flex flex-row justify-around w-[45%] md:w-[30%] lg:w-[20%] items-center border-b-2 border-white hover:bg-white hover:text-black transition-all duration-500 hover:rounded-2xl p-2" onClick={() => getFile(participateWay.participateWayFilePath)}>Ver Documento</button> : null}
                            </div>

                        </div>
                        <p>
                            {participateWay.participateWayDescription.split('\r\n').map((item, i) => {
                                return <span key={i}>{item}<br /></span>
                            })}
                        </p>
                    </div>
                    {participateWay.participateWayVideoPath ?  showYoutubeVideo() : participateWay.participateWayImagePath && showImage()}
                </div>
                {(participateWay.participateWayVideoPath && participateWay.participateWayImagePath) && showImage()}
            </div>
        </div>
    );
}
 
export default ParticipateItem2;